module.exports = __webpack_public_path__ + "static/media/tipydl.f6122bdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tipydl.png
// module id = 444
// module chunks = 0